const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.setAttribute('style', `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

// Zoom in animation logic
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));

  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

    window.addEventListener(
      'scroll',
      throttle(() => {
        if (!elementIsVisible) return;

        element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
      }),
      { passive: true }
    );
  });
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100;
  }

  // When the image is in the viewport
  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}

/* =====================================================
   CLINICCEL - Carrusel de portada
   Las diapositivas de la 2 en adelante salen con
   loading="lazy" y a veces no llegan a cargar nunca, asi
   que al rotar el carrusel se ve un rectangulo negro.
   Aqui las pasamos a carga inmediata, con prioridad baja
   para no competir con la primera imagen.
   ===================================================== */
function cliniccelPrecargaBannerPortada() {
  const imgs = document.querySelectorAll('.carousel-slide .slide-image img[loading="lazy"]');
  imgs.forEach((img) => {
    img.setAttribute('fetchpriority', 'low');
    img.loading = 'eager';
  });
}

cliniccelPrecargaBannerPortada();
window.addEventListener('DOMContentLoaded', cliniccelPrecargaBannerPortada);
window.addEventListener('load', cliniccelPrecargaBannerPortada);

/* =====================================================
   CLINICCEL - Boton "COTIZAR AHORA" del banner
   El banner de microsoldadura trae el boton pintado
   dentro del JPG: no es un elemento HTML, asi que no se
   le puede poner un enlace propio desde el editor de
   temas. Aqui se superpone un enlace invisible justo
   encima del boton dibujado, para que ese rectangulo
   abra WhatsApp y el resto de la diapositiva siga
   llevando a la pagina de microsoldadura.
   La posicion y el tamano estan en cliniccel-aura.css,
   en porcentajes, medidos sobre la imagen original
   (escritorio 2048x1152, movil 1024x1280).
   ===================================================== */
function cliniccelBotonBannerWhatsApp() {
  const mensaje = 'Hola, vengo del banner de la web. Necesito cotizar una reparación de microsoldadura.';
  const enlace = 'https://wa.me/56956358901?text=' + encodeURIComponent(mensaje);

  document.querySelectorAll('.carousel-slide').forEach((slide) => {
    const img = slide.querySelector('img');
    if (!img) return;

    const alt = img.getAttribute('alt') || '';
    const src = img.currentSrc || img.getAttribute('src') || '';
    const esMicrosoldadura = /microsoldadura/i.test(alt) || /banner-microsoldadura/i.test(src);
    if (!esMicrosoldadura) return;

    const contenedor = slide.querySelector('.slide-content');
    if (!contenedor) return;
    if (contenedor.querySelector('.cc-boton-banner--cotizar')) return;

    const boton = document.createElement('a');
    boton.className = 'cc-boton-banner cc-boton-banner--cotizar';
    boton.href = enlace;
    boton.target = '_blank';
    boton.rel = 'noopener';
    boton.setAttribute('aria-label', 'Cotizar ahora por WhatsApp');
    contenedor.appendChild(boton);
  });
}

cliniccelBotonBannerWhatsApp();
window.addEventListener('DOMContentLoaded', cliniccelBotonBannerWhatsApp);
window.addEventListener('load', cliniccelBotonBannerWhatsApp);

/* El carrusel arma las diapositivas con JS, asi que se
   reintenta durante los primeros segundos y despues se
   vigila el contenedor por si se vuelven a dibujar. */
(function cliniccelVigilaBannerWhatsApp() {
  let intentos = 0;
  const reloj = setInterval(() => {
    cliniccelBotonBannerWhatsApp();
    intentos += 1;
    if (intentos >= 20) clearInterval(reloj);
  }, 500);

  const arrancarObservador = () => {
    const contenedor = document.querySelector('.carousel-slides') || document.querySelector('.carousel-wrapper');
    if (!contenedor) return;
    new MutationObserver(cliniccelBotonBannerWhatsApp).observe(contenedor, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', arrancarObservador);
  } else {
    arrancarObservador();
  }
})();

if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', cliniccelBotonBannerWhatsApp);
}
